export const ObjectHelper = () => ({
    compareObjects(obj1: any, obj2: any): boolean {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
    
        // Verifica se os objetos possuem o mesmo número de chaves
        if (keys1.length !== keys2.length) {
            return false;
        }
    
        // Verifica se os objetos possuem as mesmas chaves e valores
        for (let key of keys1) {
            if (obj1[key] !== obj2[key]) {
                return false;
            }
        }
    
        return true;
    },
    areAllFieldsNull(obj: any): boolean {
        return Object.values(obj).every(value => value === null);
    }
});

export default ObjectHelper();
